import { Navigate, useLocation } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Protects a route. Optional capability or tab check:
 *  <ProtectedRoute requireCap="canUpload">...</ProtectedRoute>
 *  <ProtectedRoute>...</ProtectedRoute>  // any authenticated PIN
 */
const ProtectedRoute = ({ children, requireCap }) => {
  const { isLoading, isAuthenticated, caps } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (requireCap && !caps?.[requireCap]) {
    return (
      <div className="max-w-md mx-auto px-4 py-16 text-center" data-testid="forbidden">
        <div className="w-14 h-14 rounded-full bg-slate-100 text-slate-500 mx-auto flex items-center justify-center">
          <Lock size={22} />
        </div>
        <h1 className="mt-5 font-display text-2xl font-bold">Accesso non disponibile</h1>
        <p className="mt-2 text-sm text-slate-600">
          Il tuo ruolo non ha accesso a questa sezione. Torna ai contratti dal menu in alto.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
